module.exports = __webpack_public_path__ + "static/media/audio-mode-inactive.be54b228.svg";